var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w120 mc mt20 pt20 pb20 pl20 pr20 bg-w my-office"},[_c('p',{staticClass:"pb20 w100 tx-c font-18"},[_vm._v("事务查询")]),_c('CardMyOfficeSWCX')],1)}
var staticRenderFns = []

export { render, staticRenderFns }